<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">

    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  Dealers:
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)">
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button class="btn btn-info btn-sm" type="button" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>

              <div style="margin-top: 12px;">
                <div class="filtro ng-star-inserted" style="margin: 10px 22px 6px 0px;">
                  Tipos O.S.:
                </div>
                <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                  <button type="button" class="btn btn-outline-info btn-sm"
                    (click)="abrirModalTipos()">
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Selecionar Tipos de O.S.
                  </button>

                  <span
                    class="btn btn-outline-info btn-sm"
                    *ngFor="let tipo of filtrosTipoOs.selecionados()"
                    style="text-transform: uppercase;"
                    [pTooltip]="tipo.descricao"
                    tooltipPosition="top"
                    (click)="removerTipo(tipo)">
                    {{ tipo.nome }}
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>

            <p-dialog header="Selecione os Tipos de O.S."
              [(visible)]="displayModalTipos"
              [modal]="true"
              [draggable]="false"
              [resizable]="false"
              [style]="{width: '600px'}"
              [contentStyle]="{'max-height':'420px','overflow':'auto'}">

              <div style="margin-bottom: 12px;">
                <input type="text" class="form-control form-control-sm"
                  placeholder="Filtrar tipos de O.S..."
                  [(ngModel)]="filtroTipoTexto" />
              </div>

              <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;">
                <button *ngFor="let tipo of tiposFiltrados()"
                  type="button"
                  (click)="toggleTipo(tipo)"
                  [ngStyle]="{
                    'background-color': tipo.selecionado ? '#0b3d66' : '#0d90f2',
                    'color': '#ffffff',
                    'border': 'none',
                    'border-radius': '4px',
                    'padding': '8px 6px',
                    'font-size': '0.8rem',
                    'cursor': 'pointer',
                    'white-space': 'nowrap',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis'
                  }"
                  [pTooltip]="tipo.descricao"
                  tooltipPosition="top">
                  {{ tipo.nome }}
                </button>
              </div>

              <ng-template pTemplate="footer">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                  (click)="limparTipos()">
                  <i class="fa fa-trash" aria-hidden="true"></i> Limpar
                </button>
                <button type="button" class="btn btn-info btn-sm"
                  (click)="confirmarTipos()">
                  OK
                </button>
              </ng-template>
            </p-dialog>

            <hr>

            <div class="row ptb50">
              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Inicial:
                </div>

                <p-calendar
                  [(ngModel)]="dataInicial"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  styleClass="p-iputtext-sm"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  (onClearClick)="limpaDataInicial()"
                  placeholder="Data Inicial"
                  showButtonBar="true">
                </p-calendar>
              </div>

              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Final:
                </div>

                <p-calendar
                  [(ngModel)]="dataFinal"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  styleClass="p-iputtext-sm"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  (onClearClick)="limpaDataFinal()"
                  placeholder="Data Final"
                  showButtonBar="true">
                </p-calendar>
              </div>

              <div class="col col-4">
                <button type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  Filtrar
                  <i class="fas fa-search"></i>
                </button>

                <button
                  [class.btn-info]="!getListagemComFiltros()"
                  [class.btn-warning]="getListagemComFiltros()"
                  class="btn mt-3"
                  type="button"
                  (click)="exibirFiltro()">
                  Mais filtros
                  <em class="fa fa-filter"></em>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>
                  Export Excel
                </button>
              </div>
            </div>

            <hr>

          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>

        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div *ngIf="dealersDados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      Nenhum registro para exibir.
    </div>

    <p-table
      #dt
      *ngIf="dealersDados?.length > 0"
      [value]="dealersDados"
      dataKey="numeroChassi"
      selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [columns]="selectedColumns"
      [paginator]="dealersDados?.length > 10"
      [rows]="10"
      [loading]="loading"
      [autoLayout]="true"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,20,30,50,100]"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registro(s)"
      [globalFilterFields]="[
        'numeroChassi',
        'dealerUltimaPassagem',
        'dataUltimaPassagem',
        'numeroOs'
      ]"
      id="excel-table">

      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="Filtro Geral..." />
          </span>

          <p-multiSelect
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} colunas selecionadas"
            [style]="{minWidth: '200px'}"
            placeholder="Colunas">
          </p-multiSelect>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
       <th
          class="text-center"
          [pSortableColumn]="col.sortField || col.field"
          style="background-color:black;color:white;">
          {{ col.header }}
          <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Sort" />
        </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="text-center">
              {{ item[col.field] }}

            </td>
          </ng-container>
        </tr>
      </ng-template>

    </p-table>

  </div>
</div>

<p-dialog
  header="Definir filtros"
  [(visible)]="displayFiltros"
  [style]="{width: '550px'}"
  [modal]="true"
  [draggable]="false">

  <form [formGroup]="form">
    <div class="container striped-rows">

      <div class="row ptb5">
        <div class="col col-4">
          Chassi
        </div>

        <div class="col col-8">
          <input
            class="form-control form-control-sm"
            type="text"
            placeholder="Informe o chassi"
            formControlName="numeroChassi">
        </div>
      </div>

    </div>
  </form>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>

    <button type="button" class="btn btn-info" (click)="filtroAPI()">
      Filtrar
    </button>
  </ng-template>
</p-dialog>

<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'Selecione os Dealers'"
  [filterPlaceholder]="'Filtrar Dealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="veiculosSemPassagens" position="bottom-right"></p-toast>